/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatBottomSheet } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IceexpansionpanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,  ChartTypes,
  SECTION_CONTROL_ALIGNMENT
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { ReportService } from 'projects/icemedx-lib/src/services/report/report.service';
import { ScheduleService } from 'projects/icemedx-lib/src/services/schedule/schedule.service';
import { MedicalcodesService } from 'projects/icemedx-lib/src/services/medicalcodes/medicalcodes.service';

import { report, ReportBarCodeType, reportDataField, ReportDataTypes, reportField, reportObject, ReportObjectType, reportSection, ReportSectionTypes, reportSummationField, reportSystemData, reportSystemField, ReportSystemFieldTypes, reportTextField, Report_Alignment, Report_Border_Style, Report_Layout_Type, Report_Mode_Type, Report_Page_Sizes } from '../../../../icemedx-lib/src/models/reports/report';
import { ViewreportComponent } from '../viewreport/viewreport.component';
import { reportdata } from 'projects/icemedx-lib/src/models/reports/reportdata';
import { SignerService } from '../../../../icemedx-lib/src/login/signer.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { IceMultimediaService } from '../../../../icemedx-lib/src/services/multimedia/icemultimedia.service';

@Component({
  selector: 'app-printreport',
  templateUrl: './viewreport.component.html',
  styleUrls: ['./viewreport.component.scss'],
  providers: [IceNavService, AppService]
})
export class PrintreportComponent extends ViewreportComponent implements OnInit {
  // data members

  // member settings

  // sample member settings

  constructor(appSvc: AppService,
    navSvc: IceNavService,
    loginSvc: LoginService,
    router: Router,
    activatedRoute: ActivatedRoute,
    rptService: ReportService,
    schService: ScheduleService,
    signerSvc: SignerService,
    codeSvc: MedicalcodesService,
    domainSvc: DomainService,
    changeDetectorRefs: ChangeDetectorRef,
    bottomSheet: MatBottomSheet) {

    super(appSvc, navSvc, loginSvc, router, activatedRoute,
      rptService, schService, signerSvc, codeSvc, domainSvc,
      changeDetectorRefs, bottomSheet);

    appSvc.setHideBreadCrum(true);
    this.setReportMode(Report_Mode_Type.modePrint);
  }

  ngOnInit() {
  }

  viewSetup(rep: report): IcepanelcontainerSettings {
    if (rep.RPTSECTION.length > 0)
      this.setReportLayoutType(Report_Layout_Type.rltSectionLayout);

    let setup: IcepanelcontainerSettings = null;
    try {
      if (rep == null) {
        return null;
      }

      setup = super.viewSetup(rep);
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  onLoadReportData(rep: report, repData: reportdata, sections: IcepanelsectionSettings[]): void {
    if (this.getReportLayoutType() == Report_Layout_Type.rltSectionLayout) {
      const reportCanvas: HTMLCanvasElement = document.getElementById("reportCanvas") as HTMLCanvasElement;
      this.onPrint(reportCanvas);
    }
  }

  onPrint(reportCanvas: HTMLCanvasElement): void {
    let rptData = this.reportData;

    // To do we need the src_type to determine what to fill outputRecords with
    this.reportObj.initializeReport(); // To do we need to know the primary key
    for (let imedActy = 0; imedActy < rptData.MEDACTIVITIES.length; imedActy++) {
      let rec = rptData.getDataMedActivity(imedActy, this.reportObj.outputColumns);
      if (rec != null)
        this.reportObj.outputRecords.push(rec);
    }
    this.getReportService().onDraw(this.reportObj, reportCanvas);
  }
}
